function init() {
    $('.product-page__rating').on('click', function (){
        if($(window).width() >= 1200) {
            let offset = $('.tabs-panel__scroll').offset();
            $("html, body").animate({scrollTop: offset.top -200}, 500);
            activeState();
        } else {
            let offset = $('.review-row').position();
            $("html, body").animate({scrollTop: offset.top}, 500);
            let sectionElement = $('.review-row').find('.accordion-panel'),
                contentElement = $('.review-row').find('[data-accordion-content]');
            let contentHeight;
            sectionElement.addClass('active');
            contentHeight = $('.review-row').find('[data-accordion-content]').prop("scrollHeight");
            contentElement.css('max-height', contentHeight + 'px');
        }
    });
}

function activeState() {
    let tabLabels = document.querySelectorAll('.tabs-panel__label');
    let tabTargets = document.querySelectorAll('.tabs-panel__target');
    tabLabels.forEach((tabLabel) => {
        tabLabel.classList.contains('active') ? tabLabel.classList.remove('active') : null;
    });

    tabTargets.forEach((targetPanel) => {
        targetPanel.classList.contains('active') ? targetPanel.classList.remove('active') : null;
    });
    $('[data-panel-id="#panelOpinions"]').addClass('active');
    $('#panelOpinions').addClass('active');
}
export default {init};


// WEBPACK FOOTER //
// ./src/scripts/product-page-rating.js